import { z } from "zod";
/**
 * THREE FACTS — optional things a player shares at join ("hates mornings,
 * never loses at Monopoly, scared of geese"). The host reads them out, so they
 * are checked before they're accepted. Kept beside the castle, never in the
 * game log, and deleted with it.
 */
export const FACT_MAX = 48;
export const FactsRequest = z.object({
    facts: z.array(z.string().max(FACT_MAX)).max(3),
});
// Strong words are caught anywhere, even spelt out with dots ("f.u.c.k").
const ANYWHERE = ["fuck", "cunt", "nigg", "shit", "wank", "twat"];
// Milder words only as whole words, so Essex, peacock and Dickens are fine.
const WHOLE_WORDS = [
    "bitch", "bitches", "bastard", "dick", "dicks", "cock", "cocks", "pussy", "slag", "whore", "slut", "piss", "pissed", "arse",
    "arsehole", "bollocks", "tosser", "prick", "fag", "fags", "faggot", "retard", "retarded", "spastic", "spaz", "paki", "tranny",
    "dyke", "porn", "sex", "sexy", "nazi", "rape", "raped",
];
/** Why a fact can't be read out, or null if it's fine. */
export function factProblem(fact) {
    const letters = fact.toLowerCase().replace(/[^a-z]/g, "");
    const words = fact.toLowerCase().split(/[^a-z]+/).filter(Boolean);
    if (ANYWHERE.some((w) => letters.includes(w)) || words.some((w) => WHOLE_WORDS.includes(w))) {
        return "Keep it family-friendly: the host reads these out.";
    }
    if (/https?:|www\.|\.com|@/i.test(fact))
        return "No links or email addresses, please.";
    if (/\d{6,}/.test(fact.replace(/\s/g, "")))
        return "No phone numbers, please.";
    return null;
}
/** Tidy and check up to three facts. */
export function cleanFacts(facts) {
    const out = [];
    for (const raw of facts) {
        const f = raw.replace(/\s+/g, " ").trim().replace(/[.!]+$/, "");
        if (!f)
            continue;
        const problem = factProblem(f);
        if (problem)
            return { ok: false, message: problem };
        out.push(f.charAt(0).toUpperCase() + f.slice(1));
    }
    return { ok: true, facts: out.slice(0, 3) };
}
//# sourceMappingURL=facts.js.map